// Typing for the env vars in Window
const win = window as Window & { env?: { apiBaseUrl?: string, identityUrl?: string, serviceUrl?: string, locales?: string }; };

export const environment = {
  // This is for running on staging env
  production: true,
  apiUrl: win.env?.apiBaseUrl ?? 'https://portal.strdx.com',
  identityUrl: win.env?.identityUrl ?? 'https://identity.strdx.com',
  serviceUrl: win.env?.serviceUrl ?? 'https://service.strdx.com',
  locales: win.env?.locales.split(',') ?? ['en-GB', 'sv-SE'] ,
  defaultLocale: 'en-GB'
};
